/**
 * What a preview body says when it has nothing to draw.
 *
 * One body for every refusal — a text file past the cap, a fetch that did not land, a PDF pdf.js
 * will not open — because they are the same thing on screen: a sentence naming why, and under it
 * the way out, which is the Download the footer keeps whatever the body managed to draw. The
 * sentences themselves are the view-model's; this places them.
 */

import type { PreviewFallback } from "../../lib/document-preview-view";

export function PreviewFallbackBody({ fallback }: { fallback: PreviewFallback }) {
  return (
    <div
      data-testid="document-preview-fallback"
      className="flex flex-col items-center gap-1 px-5 py-10 text-center"
    >
      <p className="font-medium text-foreground text-sm">{fallback.message}</p>
      <p className="text-muted-foreground text-xs/relaxed">{fallback.hint}</p>
    </div>
  );
}
